<template lang="html">
  <tr>
    <th scope="row">
      <div class="form-group position-relative">
        <!-- <input type="text" name="start"  class="form-control" placeholder="" required="" @blur.stop.prevent="getFormData" v-model="start" @click.stop.prevent="showDatepicker(1)" readonly> -->
        <month-picker v-on:getChildDate="catchChildDate1"></month-picker>
      </div>
    </th>
    <td class="">
      <div class="form-group  position-relative">
        <!-- <input type="text" name="end" class="form-control" placeholder="" required="" v-model="end" @blur.stop.prevent="getFormData" @click.stop.prevent="showDatepicker(2)" readonly> -->
        <month-picker v-on:getChildDate="catchChildDate2"></month-picker>
      </div>
    </td>
    <td>
      <div class="form-group">
        <input type="text" name="experience" class="form-control" placeholder="" required="" v-model="experience" @blur.stop.prevent="getFormData" >
      </div>
    </td>
    <td>
      <span class="remove" @click="remove">-</span>
    </td>
  </tr>

</template>

<script>
import monthPicker from './monthpicker.vue'
export default {
  name:'step3',
  props:["index"],
  data(){
    return{
      datepickerStartShow:false,
      datepickerEndShow:false,
      start:'起始年月',
      end:'结束年月',
      experience:''
    }
  },
  components:{
    monthPicker
  },
  methods:{
    remove(){
      let index = this.index
      this.$emit('getRemoveIndex',index)
    },
    getFormData(){
      let index = this.index
      let formData = []
      formData[index]={
        startdate:this.start,
        enddate:this.end,
        exp:this.experience,
      }
      this.$emit('getFormData',{formData,index:index})
    },
    catchChildDate1(date){
      this.start = date.date
    },
    catchChildDate2(date){
      this.end = date.date
    },
    showDatepicker(type){
      const START = 1
      const END = 2
      if(type==START){
        this.datepickerEndShow = false
        this.datepickerStartShow = !this.datepickerStartShow
      }else{
        this.datepickerStartShow=false
        this.datepickerEndShow = !this.datepickerEndShow
      }
    }
  },
  mounted(){
    document.body.addEventListener('click',(e)=>{
      this.datepickerStartShow = false
      this.datepickerEndShow=false
    })
  }
}
</script>

<style lang="css" scoped>
.form-control[readonly]{
  background: none;
}
.width-25{
  width: 25%;
}
th{font-weight: normal!important;}
.remove{
  background: #18a689;
  color: #fff;
  width: 25px;
  height: 25px;
  line-height: 22px;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  font-size: 25px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/step3.vue